export const UserStorageKey = 'colgate_user';
export const AuthorizationStorageKey = 'colgate_user_authorization';
export const VerifiedStripeKey = 'colgate_has_verified_stripe';
export const WelcomeStorageKey = 'colgate_user_shown_welcome';
export const WelcomeShortcutStorageKey = 'colgate_user_shown_shortcut';
export const ReferralKey = 'colgate_referral';
export const SkipStripe = 'colgate_skip_stripe';
export const StripeRegistrationUrl = 'colgate_stripe_registration_url';
export const refCode = 'colgate_user_unique_referral_code';
export const SecondLogin = 'colgate_user_second_login';
export const StripeConnected = 'colgate_user_stripe_connected';
export const StripeStatus = 'colgate_user_stripe_account_status';
export const IsAdminApproved = 'colgate_user_is_admin_approved'; // to be used later in flow
export const DisplayPendingModal = 'colgate_user_display_pending_modal';
export const AfterWelcomeModalLastDisplayed =
  'colgate_user_after_welcome_modal_last_displayed';
export const AfterWelcomeModalLastDisplayedDontShowAgain = 
  'colgate_user_after_welcome_modal_dont_show_again';
export const QRAccountStatusTrueModalShown = 'has_quick_reco_acc_true_modal_shown';
